import { handleActions } from 'redux-actions';
import {
  COURSE_QUEST_REQUEST,
  COURSE_QUEST_SUCCESS,
  COURSE_QUEST_FAILURE,
  COURSE_QUEST_SUBMIT_REQUEST,
  COURSE_QUEST_SUBMIT_SUCCESS,
  COURSE_QUEST_SUBMIT_FAILURE,
} from 'constants/ActionTypes';

const initialState = {
  questionnaireError: null,
  questionnaireLoaded: false,
};

export default handleActions({
  [COURSE_QUEST_REQUEST]: (state, { RootQAElementID }) => ({
    ...state,
    RootQAElementID,
    questionnaireError: null,
    questionnaireLoaded: false,
  }),
  [COURSE_QUEST_FAILURE]: (state, { questionnaireError }) => ({
    ...state,
    questionnaireError,
  }),
  [COURSE_QUEST_SUCCESS]: (state, { questionnaire }) => ({
    ...state,
    questionnaire,
    questionnaireLoaded: true,
  }),
  [COURSE_QUEST_SUBMIT_REQUEST]: state => ({
    ...state,
  }),
  [COURSE_QUEST_SUBMIT_FAILURE]: (state, { questionnaireError }) => ({
    ...state,
    questionnaireError,
  }),
  [COURSE_QUEST_SUBMIT_SUCCESS]: state => ({
    ...state,
  }),
}, initialState);



// WEBPACK FOOTER //
// ./src/reducers/CourseQuestionnaireReducer.js